import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export const COLOR_MARCA = "#2471A3";

// Tarjeta del detalle del pedido: encabezado con ícono y título en el color de la marca.
// extra: contenido opcional a la derecha del encabezado (ej: total).
function TarjetaDetalle({ icono, titulo, extra, children, sx }) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden", height: "100%", ...sx }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ px: 1.5, py: 1, bgcolor: "#EAF2F8", borderBottom: "1px solid", borderColor: "divider" }}
      >
        <Box sx={{ color: COLOR_MARCA, display: "flex" }}>{icono}</Box>
        <Typography variant="subtitle2" fontWeight={700} color={COLOR_MARCA}>
          {titulo}
        </Typography>
        {extra ? <Box sx={{ ml: "auto !important" }}>{extra}</Box> : null}
      </Stack>
      <Box sx={{ p: 1.5 }}>{children}</Box>
    </Paper>
  );
}

export default TarjetaDetalle;
